import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

export const template = styled.div`
 ${({ displayState }) => css`
    position: sticky;
    top: 0px;
    background-color: ${displayState?.background ?? '#FFFFFF'};
 `}
`;

export default Wrapper(template);